import { IRobaTranslations } from '@/i18n/IRobaTranslations'

const translations: IRobaTranslations = {
  COMMON: {
    CANCEL: 'Cancel',
    CLEAR_ALL_FILTERS: 'Clear all filters',
    CLEAR_FILTERS: 'Clear filters',
    COMPANY: 'Company',
    DATE: 'Date',
    DATE_CREATED: 'Date created',
    DATE_FROM: 'Date from',
    DATE_PLACEHOLDER: 'Day | Month | Year',
    DATE_UNTIL: 'Date until',
    DOCUMENTS: 'Documents',
    DOWNLOAD: 'Download',
    EMAIL: 'Email',
    FILTERS: 'Filters',
    HELP: 'Help',
    IMPERSONATE: 'Impersonate',
    NAME: 'Name',
    NEXT: 'Next',
    NO: 'No',
    PREVIOUS: 'Previous',
    NO_RESULTS: 'Sorry, we found no {0}',
    PASSWORD: 'Password',
    REMOVE: 'Remove',
    SORT_BY: 'Sort by',
    STATUS_PORTAL_FILTER_TITLE: 'Status portal',
    USER: 'User',
    VERSIONS: 'Versions',
    YES: 'Yes',
    PORTAL: 'Portal',
    MY_ENVIRONMENT: 'My environment'
  },
  MENU: {
    DASHBOARD: 'Dashboard',
    SHIPMENT_REQUEST: 'Shipment Request',
    DOCUMENTS: 'Documents',
    USER_MANAGEMENT: 'Users',
    COMPANIES: 'Companies'
  },
  MY_ENVIRONMENT: {
    YOUR_PROFILE: 'Your profile',
    USERS: 'Users',
    NOTIFICATIONS: 'Notifications',
    SUPPORT: 'Support',
    LOG_OUT: 'Log out',
    CHANGE_COMPANY: 'Change company',
    CHANGE_USER: 'Change User',
    PROFILE: {
      ROLE: 'Role',
      COMPANY: 'Company',
      CUSTOMER_NR: 'Customer no.',
      FIRST_NAME: 'First name',
      LAST_NAME: 'Last name',
      STATUS_PORTAL: 'Status portal',
      PERSONAL_INFORMATION: 'Personal Information',
      YOUR_NOTIFICATIONS: 'Your notifications',
      DOCUMENT_NOTIFICATION: 'Document Notification',
      GENERAL_NOTIFICATION: 'General Notification',
      GENERAL_NOTIFICATION_TEXT: 'A general notification will be sent at the end of each day, letting you know that there are new documents added to the portal.',
      RECEIVE_GENERAL_NOTIFICATION: 'Receive general notifications',
      NO_SUBSCRIPTIONS: 'No subscriptions'
    },
    USER: {
      ACTIVE_DESCRIPTION: 'Are you sure you want to change the status of this user to active? Notice that all users created by this Administrator will be active too.',
      ACTIVE_TITLE: 'Change user status to active?',
      ADMINISTRATOR: 'Customer (Administrator)',
      ADMINISTRATOR_DESCRIPTION: 'An Administrator can create users and managers and add e-mail addresses under notifications.',
      CHANGE_TO_ACTIVE: 'Change to active',
      CHANGE_TO_INACTIVE: 'Change to inactive',
      CREATE_USER: 'Create user',
      CREATE_USER_DESCRIPTION: 'The user you create will have the status “Inactive” until the user confirms the e-mail address and creates a password.',
      DELETE: 'Delete user',
      DELETE_DESCRIPTION: 'Are you sure you want to delete this user? Notice that all users created by this Administrator will be lost too.',
      DESCRIPTION: 'Users have access to the portal. A user remains inactive when the e-mail hasn’t been confirmed.',
      EDIT_USER: 'Edit user',
      EDIT_USER_DESCRIPTION: 'The user you edit will have the status “Inactive” until the user confirms the e-mail address and creates a password.',
      EMAIL_LANGUAGE: 'Select language of emails to be received',
      EMAIL_LANGUAGE_DISABLED_LABEL: 'Email language',
      FIRST_NAME: 'First name',
      INACTIVE_DESCRIPTION: 'Are you sure you want to change the status of this user to inactive? Notice that all users created by this Administrator will be inactive too.',
      INACTIVE_TITLE: 'Change user status to inactive?',
      LAST_NAME: 'Last name',
      MANAGER: 'Manager',
      MANAGER_DESCRIPTION: 'A manager has the same rights as a user but can also create users and add e-mails under notifications.',
      NO_USERS_FOUND: 'Sorry, we found no users',
      ROLE: 'Role',
      ROW_LABEL: {
        NAME: 'Name',
        LAST_LOGIN: 'Last login',
        LINKED_COMPANIES: 'Linked companies'
      },
      SEARCH_TEXT: 'Search for a user by first name, last name or e-mail',
      SEARCH_TEXT_COMPANY: 'Search for a user by first name, last name, company, e-mail or customer no.',
      SET_STATUS_ACTIVE: 'Set status to active',
      SET_STATUS_INACTIVE: 'Set status to inactive',
      STATUS_PORTAL: 'Status',
      SUPERADMIN: 'Super admin',
      SUPERADMIN_DESCRIPTION: '',
      SUPPORT: 'Roba support',
      SUPPORT_DESCRIPTION: 'Roba support can impersonate a user and help with questions about the portal',
      USER: 'User',
      USER_DESCRIPTION: 'A user can access the portal and can see all documents.'
    },
    NOTIFICATION: {
      ADDED_EMAIL_ADDRESSES: 'Added e-mail addresses',
      ADD_EMAIL: 'Add e-mail',
      ADD_EMAIL_DESCRIPTION: 'Notifications will be send if a new type of document is uploaded to the portal or you will receive emails with the documents included.',
      ADD_EMAIL_TO_NOTIFICATION: 'Add e-mail address to notifications',
      DELETE_EMAIL: 'Delete e-mail',
      DELETE_EMAIL_NOTE: 'E-mail will be removed from these documents',
      EDIT_EMAIL: 'Edit e-mail',
      EMAIL_DESCRIPTION: 'Added e-mail addresses will receive {0} by e-mail when they are uploaded to the portal by Roba Metals.',
      EMAIL_SEARCH: 'Type in the e-mail you are searching',
      INVOICES: 'Invoice',
      NOTIFICATION_TEXT: 'Notifications will be sent if a new type of document is uploaded to the portal or you will receive e-mails with the documents included.',
      NOTSET: 'Not set',
      NO_EMAILS_ADDED: 'No e-mail addresses added',
      OPTIONS: 'Notification options',
      OPTIONS_TEXT: 'Selected documents will be send to the e-mail address when they are uploaded to the portal. A general notification will be send at the end of each day, letting the user know that there are new documents in portal.',
      OPTIONS_SELECT_DOCUMENTS: 'Select documents to be send by e-mail',
      PACKINGSLIPS: 'Packing slip & Certificates',
      SALESORDERS: 'Sales order',
      SALESAGREEMENTS: 'Sales agreement',
      LANGUAGE: {
        NL: 'Dutch',
        DE: 'German',
        FR: 'French',
        EN: 'English'
      }
    }
  },
  LOGIN: {
    LOGIN: 'Login',
    FORGOT_PASSWORD: 'Forgot password',
    GENERAL_PURCHASING_CONDITIONS: 'General Purchasing conditions',
    GENERAL_SALES_CONDITIONS: 'General Sales conditions',
    DISCLAIMER: 'Disclaimer'
  },
  SUPPORT: {
    BACK_TO_LOGIN: 'To login',
    TITLE: 'Support',
    TEXT: 'If you are having trouble with the portal or questions about the content, please contact your accountmanager or contact us by email or telephone.'
  },
  CREATE_PASSWORD: {
    CREATE_PASSWORD: 'Create a password',
    REPEAT_PASSWORD: 'Repeat password',
    CREATE: 'Create account',
    VALIDATION: {
      LENGTH: 'At least 7 characters',
      ONE_LOWERCASE: 'At least one lowercase',
      ONE_SPECIAL_CHARACTER: 'At least one symbol',
      EQUAL_PASSWORDS: 'Equal passwords'
    }
  },
  REQUEST_PASSWORD: {
    REQUEST: 'Request new password',
    REQUEST_PASSWORD: 'Forgot your password',
    REQUEST_PASSWORD_SENT: 'We have sent you an email',
    TEXT: 'If you are having trouble with the portal or questions about the content, please contact your accountmanager or contact us by email or telephone.'
  },
  IMPERSONATE: {
    TITLE: 'Customers - Impersonate mode',
    COMPANY_PLACEHOLDER: 'Search or select a company',
    USER_PLACEHOLDER: 'Search or select a user'
  },
  SET_COMPANY: {
    TITLE: 'Select company',
    COMPANY_PLACEHOLDER: 'Search or select a company'
  },
  VALIDATION_ERROR: {
    ROLECREATE_NOTALLOWED: 'Select a role to continue',
    USERNAME_REQUIRED: 'E-mail required',
    LASTNAME_REQUIRED: 'Lastname required',
    FIRSTNAME_REQUIRED: 'Firstname required',
    PASSWORD_REQUIRED: 'Passwords is required',
    PASSWORD_DIFFERENT: 'Passwords are different',
    NEWPASSWORD_REQUIRED: 'Password is required',
    REPEATPASSWORD_REQUIRED: 'Password is required',
    EMAIL_REQUIRED: 'E-mail is required',
    NAME_REQUIRED: 'Name is required',
    MINIMUM_ONE_TYPE: 'One selection is required',
    PASSWORDTOOSHORT: 'Password is too short',
    PASSWORDREQUIRESNONALPHANUMERIC: 'The password requires at least one special character.',
    PASSWORDREQUIRESLOWER: 'The password requires at least one lowercase character.',
    USERNAMEALREADYTAKEN: 'Username already taken',
    EMAILALREADYTAKEN: 'E-mail already taken',
    LOGIN_INCORRECT: 'Login incorrect',
    CUSTOMERNR_REQUIRED: 'Customer no. is required',
    COMPANYNAME_REQUIRED: 'Companyname is required',
    CUSTOMERNRALREADYTAKEN: 'Customer nr. already taken',
    EMAIL_INVALID: 'E-mail invalid',
    TOKEN_REQUIRED: 'Token required',
    INVALIDTOKEN: 'Your email activation is expired. Please click on “Forgot Password” at the login page to create a new one.',
    USER_MUST_HAVE_COMPANY: 'Your account is no longer linked. If not correct, please contact the Roba Metals Account Manager.'
  },
  ENUM: {
    PORTAL_STATUS: {
      ACTIVE: 'Active',
      INACTIVE: 'Inactive'
    },
    USER_ROLE: {
      USER: 'User',
      MANAGER: 'Manager',
      ADMINISTRATOR: 'Administrator',
      SUPERADMIN: 'Super admin',
      SUPPORT: 'Support'
    },
    DOCUMENT_TYPE: {
      NOTSET: 'Not set',
      CERTIFICATES: 'Certificates',
      INVOICES: 'Invoices',
      SALESORDERS: 'Sales orders',
      PACKINGSLIPS: 'Packing slip',
      SALESAGREEMENTS: 'Sales agreements'
    },
    DOCUMENT_SORT: {
      UPLOADDATEASC: 'Date ascending',
      UPLOADDATEDESC: 'Date descending',
      DOCUMENTTYPEASC: 'Document type'
    },
    DOCUMENT_SEARCH_TYPE: {
      NONE: 'None',
      ARTICLENR: 'Your article no.',
      CLIENTREFERENCE: 'Your reference no.',
      SALESORDER: 'Sales order no.',
      SALESAGREEMENT: 'Sales agreement no.',
      PACKINGSLIP: 'Packing slip number',
      BATCHNR: 'Batch no.',
      CERTIFICATENR: 'Certificate no.',
      INVOICENR: 'Invoice no.'
    }
  },
  DASHBOARD: {
    DOCUMENTS_ADDED: 'Documents added since your last visit',
    LAST_VISIT: 'Last visit',
    TONNAGE_DELIVERED: 'Tonnage delivered this year to',
    NEW_DOCUMENTS: 'New Documents',
    DOCUMENTS: 'Documents',
    SUPPORT_BLOCK: {
      ACTION: 'Any questions, contact us',
      TITLE: 'Trusted partner in metal'
    }
  },
  DOCUMENTS: {
    DOCUMENT_TYPE: 'Document type',
    GROUP_FUTURE: 'Future',
    GROUP_TODAY: 'Today',
    GROUP_THIS_WEEK: 'This week',
    GROUP_THIS_MONTH: 'This month',
    GROUP_LAST_MONTH: 'Last month',
    GROUP_THIS_YEAR: 'This year',
    GROUP_PREVIOUS_YEARS: 'Previous years',
    GROUP_SEARCH_RESULT: 'Search results',
    GROUP_SEARCH_RELATED: 'Related documents for {0} "{1}"',
    SEARCH_TEXT: 'Type in your {0} to find corresponding documents',
    NO_DOCUMENTS_FOUND: 'Sorry, we found no documents',
    NO_VERSIONS_FOUND: 'Sorry, we found no versions',
    BATCH_NUMBER: 'Batch no.',
    CUSTOMER_NUMBER: 'Customer no.',
    EXTERNAL_CUSTOMER_REFERENCE: 'Customer ref.',
    ROBA_NUMBER: 'Roba no.',
    PACKING_SLIP_NUMBER: 'Packing slip no.',
    INVOICE_NUMBER: 'Invoice no.',
    CERTIFICATE_NUMBER: 'Certificate no.',
    DOWNLOAD_DOCUMENTS: 'Download documents',
    PREPARING_YOUR_DOWNLOAD: 'Preparing your download',
    SELECTED_DOCUMENTS: 'Selected documents',
    PREVIEW: 'Preview',
    SELECT_DOCUMENT: 'Select document',
    RELATED_DOCUMENTS: 'Related documents',
    VERSION_HISTORY: 'Version history',
    DOWNLOAD: 'Download',
    UPLOAD_DATE: 'Upload date',
    VERSION_NUMBER: 'Version no.',
    MULTIPLE_BATCHES: 'Multiple batches',
    CERTIFICATE_MULTIPLE_BATCHES: 'Certificate for multiple batches'
  },
  COMPANIES: {
    META_TITLE: 'Companies',
    CREATE_COMPANY: 'Create company',
    SEARCH_PLACEHOLDER: 'Search for a company by name or customer no.',
    ROW_LABELS: {
      COMPANY_NAME: 'Company name',
      CUSTOMER_NR: 'Customer no.',
      DATE_CREATED: 'Date created',
      LAST_LOGIN: 'Last login',
      STATUS: 'Status'
    }
  },
  COMPANY: {
    ADD_COMPANY: {
      ACCESS_TO: 'Access to which companies?',
      BUTTON: 'Add another company',
      NO_DATA: 'No companies found',
      PLACEHOLDER: 'Search a company by name or customer no.',
      TITLE: 'Add companies'
    },
    COMBINE: 'Combine the document information of the selected companies?',
    CORPORATE: 'Corporate name',
    CORPORATE_DESCRIPTION: 'This name will be used in the portal.',
    DELETE_COMPANY: 'Delete company',
    EDIT_COMPANY: 'Edit company',
    DELETE_DESCRIPTION: 'This company disappears for all linked admins',
    SET_STATUS_ACTIVE: 'Change status to active',
    SET_STATUS_INACTIVE: 'Change status to inactive',
    STATUS_ACTIVE_TITLE: 'Change status to active?',
    STATUS_INACTIVE_TITLE: 'Change status to inactive?'
  }
}
export default translations
